import {
  BarElement,
  CategoryScale,
  ChartData,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { Bar } from 'react-chartjs-2'

import { Database_Procs_GymPercentAggregatedByLevel_Item } from '@suntex.fim/api-client'
import { getGymColumnKeys } from '@suntex.fim/assessment'
import { $ArithmeticOperation, $GymMode, GymMode } from '@suntex.fim/enums'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
)

/**
 * returns JSX for assessment gym chart
 */
function AssessmentGymCharts({
  backgroundColor,
  level,
  chartData
}: {
  backgroundColor: string
  level: GymMode
  chartData: Partial<Database_Procs_GymPercentAggregatedByLevel_Item>
}) {
  const gymModeSlug = $GymMode.describe(level).slug
  const columnKeys = getGymColumnKeys(level)
  const data: ChartData<'bar', number[], string> = {
    labels: columnKeys.map(
      (key) =>
        $ArithmeticOperation.describe($ArithmeticOperation.fromSlug(key)).label
    ),
    datasets: [
      {
        data: columnKeys.map(
          (opSlug) => chartData[`gym_${gymModeSlug}_${opSlug}`] || 0
        ),
        backgroundColor,
        borderRadius: 6,
        borderSkipped: false
      }
    ]
  }
  return (
    <Bar
      options={{
        responsive: true,
        plugins: {
          legend: { display: false },
          datalabels: {
            color: 'black',
            formatter: (value: string) => {
              return `${value}%\n` // patch:bottom margin not applicable so added with lines
            },
            font: {
              size: 14,
              weight: 700
            },
            anchor: 'end'
          },
          tooltip: {
            borderColor: '#D2D2D2',
            borderWidth: 1,
            displayColors: false,
            callbacks: {
              label: (context) => {
                const label = String(context.raw) || ''
                return ` ${label} %`
              },
              title: () => {
                return ''
              }
            },
            bodyAlign: 'center',
            backgroundColor: 'white',
            titleColor: 'black',
            bodyColor: 'black',
            bodyFont: {
              size: 14,
              weight: 700
            }
          }
        },
        maintainAspectRatio: false,
        layout: { autoPadding: true, padding: { top: 20 } },
        scales: {
          x: {
            ticks: {
              font: {
                size: 14,
                weight: 700
              }
            }
          },
          y: {
            min: 0,
            max: 100,
            // Show all major tick values
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            major: {
              enabled: true
            },
            ticks: {
              stepSize: 20, // Adjust step size to ensure 10, 50, and 100 are displayed
              callback: (value: number | string) => `${value} %`
            }
          }
        }
      }}
      data={data}
    />
  )
}

export default AssessmentGymCharts
